import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import {
    Box,
    Stack,
    Image,
    Tag,
    Text,
    Card,
    CardBody,
    CardHeader,
    Link,
} from '@chakra-ui/react';
import { format as formatDate } from 'date-fns/format';
import HtmlElements from '../HtmlElements';
import { postPath, categoryPath } from '../../utils/paths';
import ButtonLink from '../ButtonLink';

export type Post = {
    id: string;
    slug: string;
    title: string;
    date: Date;
    category: string;
    tags: string[];
    excerpt: string;
    thumb: string;
};

const PostsList = ({ posts }: { posts: Post[] }) =>
    posts.map(({ id, slug, title, date, category, excerpt, thumb }) => (
        <Card key={id} as="article" mb={8}>
            <CardHeader py={2}>
                <Stack direction="row" alignItems="center">
                    <Text
                        as="span"
                        textTransform="uppercase"
                        fontSize="sm"
                        fontWeight="bold"
                        color="gray.700"
                    >
                        {formatDate(date, 'MMMM do, yyyy')}
                    </Text>
                    <Tag>
                        <Link as={GatsbyLink} to={categoryPath(category, 1)}>
                            {category}
                        </Link>
                    </Tag>
                </Stack>
                <Link as={GatsbyLink} to={postPath(slug)}>
                    <HtmlElements.h1 size="lg">{title}</HtmlElements.h1>
                </Link>
            </CardHeader>
            <CardBody py={2}>
                <Stack direction="row" alignItems="flex-start" spacing="6">
                    <Box>
                        <HtmlElements.p mt={0} flexShrink={1}>
                            {excerpt}
                        </HtmlElements.p>
                        <ButtonLink
                            to={postPath(slug)}
                            bg="blackAlpha.800"
                            my={4}
                        >
                            Read
                        </ButtonLink>
                    </Box>
                    <Box flex="0 0 35%">
                        <Image w="100%" maxW="100%" src={thumb} />
                    </Box>
                </Stack>
            </CardBody>
        </Card>
    ));

export default PostsList;
